import { useIconData } from 'hooks/useIcon';
import { memo } from 'react';
import SVG from 'react-inlinesvg';

interface IconProps {
  iconId: string;
}

// TODO - Handle Icons8 icons when we had icons8 packs to the editor
// For now, all icon packs are from S3
export const Icon = memo(({ iconId }: IconProps) => {
  const iconData = useIconData({ iconId });

  if (!iconData) {
    return null;
  }

  const { description, svg } = iconData;
  return (
    <SVG uniquifyIDs={true} description={description} role='img' style={{ width: '100%', height: '100%' }} src={svg} />
  );
});
Icon.displayName = 'Icon';
